<script>
import { QcItemServiceProxy } from '@/service-proxies/app-v2/product.service-proxies'
import { OrderProcessItemQcServiceProxy } from '@/service-proxies/app-v2/coproduction.service-proxies'
import { getLocalStorage } from '@/utils/storage'
const qcsp = new QcItemServiceProxy()
const opiqcsp = new OrderProcessItemQcServiceProxy()

const columns = [
  {
    title: 'page_bussiness_data_quality_name_of_quality',
    dataIndex: 'itemName',
    key: 'itemName'
  },
  {
    title: 'page_job_plan_standard_value',
    dataIndex: 'standardValue',
    key: 'standardValue'
  },
  {
    title: 'page_job_plan_measured_value',
    dataIndex: 'measuredValue',
    key: 'measuredValue',
    scopedSlots: { customRender: 'measuredValue' }
  }
]
export default {
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    visible: {
      type: Boolean,
      default: false
    },
    person: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    columns() {
      return columns.map((item) => {
        return {
          ...item,
          title: this.$t(item.title)
        }
      })
    }
  },
  data() {
    return {
      formItemLayout: {
        labelCol: { span: 6 },
        wrapperCol: { span: 14 }
      },
      data: [],
      confirmLoading: false,
      form: {
        workPerson: ''
      },

      rules: {
        workPerson: [
          {
            required: true,
            message: this.$t('page_plan_choose_process_persoal'),
            trigger: 'change'
          }
        ]
      }
    }
  },
  watch: {
    visible: {
      handler() {
        if (this.visible && this.item.craftId) {
          this.getData()
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    async getData() {
      const data = await qcsp.getQcItemsByCraftId(
        this.item.craftId,
        this.item.processCode,
        this.item.sort
      )
      this.data = data.map((res, index) => {
        return {
          key: index + 1,
          itemName: res.name,
          standardValue: res.standardValue,
          measuredValue: ''
        }
      })
    },
    handleChange(value, key) {
      const newData = [...this.data]
      const target = newData.find((item) => key === item.key)
      if (target) {
        target['measuredValue'] = Number(value).toFixed(2)
        this.data = newData
      }
    },
    cancel() {
      this.$refs.ruleForm.resetFields()
      this.$emit('cancel')
    },
    save() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          const User = getLocalStorage('USER_INFO')
          const body = {
            poProcessId: this.item.id,
            producerName: this.form.workPerson,
            qcItemDTOList: this.data,
            qcName: User.user_name
          }
          this.confirmLoading = true
          opiqcsp
            .saveQcItem(body)
            .then(() => {
              this.$message.success(this.$t('save_success'))
              this.$emit('save')
              this.$refs.ruleForm.resetFields()
              this.confirmLoading = false
            })
            .catch(() => {
              this.confirmLoading = false
            })
        }
      })
    },
    handleChangePerson(value) {
      this.form.workPerson = value
    }
  }
}
</script>

<template>
  <a-modal
    :width="800"
    :title="$t('page_job_plan_add_quality')"
    :visible="visible"
    @cancel="cancel()"
    @ok="save()"
    :confirm-loading="confirmLoading"
  >
    <a-form-model
      :label-col="formItemLayout.labelCol"
      :wrapper-col="formItemLayout.wrapperCol"
      ref="ruleForm"
      :model="form"
      :rules="rules"
    >
      <a-row>
        <a-col :span="12">
          <a-form-model-item :label="$t('page_process_name')">
            {{ item.processName }}
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item :label="$t('page_plan_Process_coding')">
            {{ item.processCode }}
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item :label="$t('page_plan_order_no')">
            {{ item.orderCode }}
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item :label="$t('page_plan_product_name')">
            {{ item.productName }}
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item :label="$t('page_plan_process_persoal')" prop="workPerson">
            <a-select 
            show-search
            optionFilterProp="children"
            :placeholder="$t('please_select') + $t('page_plan_process_persoal')" 
            :value="form.workPerson" @change="handleChangePerson">
              <template v-for="(user, index) in person">
                <a-select-option :key="index" :value="user">
                  {{ user }}
                </a-select-option>
              </template>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item :label="$t('page_job_plan_workstation_work')">
            {{ item.workStationName }}
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
    <ml-table :columns="columns" :data-source="data">
      <template slot="measuredValue" slot-scope="text, record">
        <a-input-number
          :value="text"
          :step="0.01"
          @change="(value) => handleChange(value, record.key)"
        />
      </template>
    </ml-table>
  </a-modal>
</template>

<style scoped>
.ant-form-item-control {
  line-height: 39px !important;
}
</style>
